
import { Component, Input } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { FmvEntityAttribute } from '../../../../core/services/fmv-entity-attribute.service';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

interface FmvFeed {
  getId(): string;
  getName(): string;
}

class FmvFeedWrapper {
  constructor(public fmvFeed: FmvFeed, public addedToEntity: boolean) { }
}

@Component({
  selector: 'app-fmv-dialog',
  standalone: true,
  imports: [FormsModule],
  templateUrl: './fmv-dialog.component.html',
  styleUrl: './fmv-dialog.component.css'
})

export class FmvDialogComponent {
  @Input() feeds: FmvFeed[] = [];

  query = '';
  fmvFeeds: FmvFeedWrapper[] = [];
  @Input() mapEntity: any;
  constructor(public activeModal: NgbActiveModal) { }

  ngOnInit() {
    this.fmvFeeds = this.getFmvFeeds();

  }

  getFmvFeeds(): FmvFeedWrapper[] {
    if (!this.feeds || !this.mapEntity) return [];
    return this.feeds
      .filter(feed => !!feed)
      .map(feed => new FmvFeedWrapper(feed, this.entityHasFmvAttribute(feed)));
  }

  entityHasFmvAttribute(fmvFeed: FmvFeed): boolean {
    return this.mapEntity.getAttributes().some((attr: any) =>
      attr instanceof Object &&
      typeof attr.getFmvFeed === 'function' &&
      attr.getFmvFeed().getId() === fmvFeed.getId()
    );
  }

  ok() {
    const dataAttributes = this.mapEntity.getAttributes();
    dataAttributes.forEach((attr: any) => {
      if (attr instanceof FmvEntityAttribute) {
        const feed = this.fmvFeeds.find(f => f.fmvFeed.getId() === attr.getFmvFeed().getId());
        if (feed && !feed.addedToEntity) {
          this.mapEntity.removeAttribute(attr);
        }
      }
    });

    this.fmvFeeds.forEach(feed => {
      if (feed.addedToEntity) {
        const exists = dataAttributes.some((attr: any) =>
          attr instanceof FmvEntityAttribute &&
          attr.getFmvFeed().getId() === feed.fmvFeed.getId()
        );
        if (!exists) {
          this.mapEntity.addAttribute(
            new FmvEntityAttribute(feed.fmvFeed.getName(), this.mapEntity.getId(), 0, feed.fmvFeed)
          );
        }
      }
    });

    this.activeModal.dismiss('cancel');
  }

  cancel() {
    this.activeModal.dismiss('cancel');
  }
}